// src/AdminConfig/AdminConfigPage.js
import React, { useState, useMemo, useEffect } from 'react';
import ConfirmDialog from './ConfirmDialog';
import SuccessDialog from './SuccessDialog';
import './AdminConfig.css';
import ErrorDialog from "./ErrorDialog";

const AdminConfigPage = ({
    title,
    subtitle,
    configItems = [],
    initialSettings = {},
    onSave,
}) => {
    const [settings, setSettings] = useState(initialSettings);
    const [searchTerm, setSearchTerm] = useState("");
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [successOpen, setSuccessOpen] = useState(false);
    const [errorOpen, setErrorOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        setSettings(initialSettings);
    }, [initialSettings]);

    const handleToggle = (key) => {
        setSettings(prev => ({ ...prev, [key]: !prev[key] }));
    };



    // const handleNumberChange = (key, value) => {
    //     // Allow clearing the field
    //     if (value === "") {
    //         setSettings(prev => ({
    //             ...prev,
    //             [key]: ""
    //         }));
    //         return;
    //     }

    //     const num = Number(value);

    //     // Don't allow negative numbers
    //     if (num < 0) {
    //         return;
    //     }

    //     setSettings(prev => ({
    //         ...prev,
    //         [key]: num
    //     }));
    // };
    const handleNumberChange = (key, value) => {
        // Allow clearing
        if (value === "") {
            setSettings(prev => ({ ...prev, [key]: "" }));
            setValidationErrors(prev => ({ ...prev, [key]: "" }));
            return;
        }

        // Show error if decimal value is entered
        if (!Number.isInteger(Number(value))) {
            setValidationErrors(prev => ({
                ...prev,
                [key]: "Decimal values are not allowed."
            }));
        } else {
            setValidationErrors(prev => ({
                ...prev,
                [key]: ""
            }));
        }

        setSettings(prev => ({
            ...prev,
            [key]: value
        }));
    };
    const handleDateChange = (key, value) => {
        setSettings(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleDateTimeChange = (key, value) => {
        setSettings(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleSelectChange = (key, value) => {
        setSettings(prev => ({ ...prev, [key]: value }));
    };

    // New: Handle Multi-select (array of values)
    const handleMultiSelectToggle = (key, option) => {
        setSettings(prev => {
            const current = prev[key] || [];
            if (current.includes(option)) {
                return {
                    ...prev,
                    [key]: current.filter(item => item !== option)
                };
            } else {
                return {
                    ...prev,
                    [key]: [...current, option]
                };
            }
        });
    };

    const filteredItems = useMemo(() => {
        if (!searchTerm.trim()) return configItems;
        const term = searchTerm.toLowerCase().trim();
        return configItems.filter(item =>
            item.label.toLowerCase().includes(term) ||
            (item.subLabel && item.subLabel.toLowerCase().includes(term))
        );
    }, [searchTerm, configItems]);


    const handleSaveClick = () => {
        // if (Object.values(validationErrors).some(error => error)) {
        //     return;
        // }
        if (Object.values(validationErrors).some(error => error)) {
            setErrorMessage("Please correct the highlighted fields before saving.");
            setErrorOpen(true);
            return;
        }

        for (const item of configItems) {

            const value = settings[item.valueKey];

            if (item.type === "number") {

                if (
                    value === "" ||
                    value === null ||
                    value === undefined ||
                    Number(value) <= 0
                ) {
                    setErrorMessage(`${item.label} cannot be zero, negative or empty`);
                    setErrorOpen(true);
                    return;
                }
            }

            if (item.type === "date") {

                if (!value) {
                    setErrorMessage(`${item.label} is required`);
                    setErrorOpen(true);
                    return;
                }
            }

            // only validate number fields
            if (item.type === "number") {

                // skip this field
                if (item.label === "Supported file upload formats") {
                    continue;
                }

                const value = settings[item.valueKey];

                if (
                    value === "" ||
                    value === null ||
                    value === undefined ||
                    Number(value) <= 0
                ) {
                    setErrorMessage(`${item.label} cannot be zero, negative or empty`);
                    setErrorOpen(true);
                    return;
                }
            }


        }

        const fromDate = settings["Work Time Period From"];
        const toDate = settings["Work Time Period To"];

        if (
            fromDate &&
            toDate &&
            new Date(fromDate) > new Date(toDate)
        ) {
            setErrorMessage(
                "Work Time Period From cannot be greater than Work Time Period To"
            );
            setErrorOpen(true);
            return;
        }

        // const randomization = settings["Randomization of Questions"];
        // const backNavigation = settings["Back Navigation Required"];

        // if (randomization && backNavigation) {
        //     setErrorMessage(
        //         '"Randomization of Questions" and "Back Navigation Required" both cannot be enabled.'
        //     );
        //     setErrorOpen(true);
        //     return;
        // }

        setConfirmOpen(true);
    };


    const confirmSave = async () => {

        try {
            setConfirmOpen(false);

            if (onSave) {
                await onSave(settings);
            }

            setSuccessOpen(true);

        } catch (error) {

            setErrorMessage(
                error?.response?.data?.message ||
                "Failed to save configuration"
            );

            setErrorOpen(true);
        }
    };
    const closeSuccess = () => setSuccessOpen(false);

    const resetToDefault = () => setSettings(initialSettings);

    const renderInput = (item) => {
        if (item.type === 'number') {
            return (
                // <input
                //     type="number"
                //     className="input-field"
                //     // value={settings[item.valueKey] ?? ''}
                //     value={settings[item.valueKey] ?? 0}
                //     onKeyDown={(e) => {
                //         if (e.key === "-" || e.key === "e" || e.key === "E") {
                //             e.preventDefault();
                //         }
                //     }}
                //     onChange={(e) => handleNumberChange(item.valueKey, e.target.value)}
                //     min={0}
                //     max={item.max || 2000}
                // />
                <div className="number-input-wrapper">
                    <input
                        type="number"
                        className="input-field"
                        value={settings[item.valueKey] ?? ""}
                        onChange={(e) =>
                            handleNumberChange(item.valueKey, e.target.value)
                        }
                        min={0}
                        max={item.max || 2000}
                    />

                    <span className="field-error">
                        {validationErrors[item.valueKey] || "\u00A0"}
                    </span>
                </div>
            );
        }

        if (item.type === 'date') {
            return (
                <input
                    type="date"
                    className="input-field"
                    value={settings[item.valueKey] || ""}
                    onChange={(e) =>
                        handleDateChange(item.valueKey, e.target.value)
                    }
                />
            );
        }

        // ADD THIS BLOCK
        if (item.type === 'datetime') {
            return (
                <input
                    type="datetime-local"
                    className="input-field"
                    style={{ width: "180px" }}
                    value={settings[item.valueKey] || ""}
                    onChange={(e) =>
                        handleDateTimeChange(
                            item.valueKey,
                            e.target.value
                        )
                    }
                />
            );
        }

        // Beautiful Multi-Select Dropdown
        if (item.type === 'multiselect-dropdown') {
            const selected = settings[item.valueKey] || [];

            return (
                <div className="multi-select-dropdown" id={`multi-${item.valueKey}`}>
                    <div
                        className="select-trigger"
                        onClick={(e) => {
                            e.stopPropagation();
                            const el = document.getElementById(`multi-${item.valueKey}`);
                            // Close all other dropdowns first
                            document.querySelectorAll('.multi-select-dropdown').forEach(d => {
                                if (d.id !== `multi-${item.valueKey}`) d.classList.remove('open');
                            });
                            el.classList.toggle('open');
                        }}
                    >
                        <div className="selected-items">
                            {selected.length > 0 ? (
                                selected.map((val) => (
                                    <span key={val} className="selected-tag">
                                        {val}
                                        <span
                                            className="remove-tag"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleMultiSelectToggle(item.valueKey, val);
                                            }}
                                        >
                                            ×
                                        </span>
                                    </span>
                                ))
                            ) : (
                                <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>
                                    Select options...
                                </span>
                            )}
                        </div>
                        <span>▼</span>
                    </div>

                    <div className="dropdown-options">
                        {item.options.map((option) => (
                            <div
                                key={option}
                                className="option"
                                onClick={() => handleMultiSelectToggle(item.valueKey, option)}
                            >
                                <input
                                    type="checkbox"
                                    checked={selected.includes(option)}
                                    readOnly
                                />
                                {option}
                            </div>
                        ))}
                    </div>
                </div>
            );
        }

        // Default: Toggle
        return (
            <label className="toggle-switch">
                <input
                    type="checkbox"
                    checked={settings[item.valueKey] ?? false}
                    onChange={() => handleToggle(item.valueKey)}
                />
                <span className="slider"></span>
            </label>
        );
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.multi-select-dropdown')) {
                document.querySelectorAll('.multi-select-dropdown').forEach(el => {
                    el.classList.remove('open');
                });
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    return (
        <>
            <div className="admin-config-container">
                {/* <div className="admin-config-header">
          <div>
            <h1 className="admin-config-title">{title}</h1>
            <p className="admin-config-subtitle">{subtitle}</p>
          </div>
          <input
            type="text"
            className="search-box"
            placeholder="Search settings..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div> */}

                <div className="config-card">
                    <div className="config-section-title">{title}</div>

                    {filteredItems.length > 0 ? (
                        filteredItems.map((item, index) => (
                            <div key={index} className="config-item">
                                <div className="config-label-wrapper">
                                    <div className="config-main-row">
                                        <span className="config-label-text">{item.label}</span>
                                        <div className="info-tooltip">
                                            <span className="info-icon">ⓘ</span>
                                            <span className="tooltip-text">{item.tooltip}</span>
                                        </div>
                                    </div>
                                    {/* {item.subLabel && <small className="config-sub-label">{item.subLabel}</small>} */}
                                </div>
                                {renderInput(item)}
                            </div>
                        ))
                    ) : (
                        <div className="no-results show">
                            No matching settings found for "{searchTerm}"
                        </div>
                    )}
                </div>

                <div className="action-buttons">

                    <button className="save-btn" onClick={handleSaveClick}>
                        💾 Save Changes
                    </button>
                </div>
            </div>

            <ConfirmDialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                onConfirm={confirmSave}
                title="Confirm Save Changes"
            />

            <SuccessDialog
                open={successOpen}
                onClose={closeSuccess}
                title="Settings Saved Successfully!"
            />
            <ErrorDialog
                open={errorOpen}
                onClose={() => setErrorOpen(false)}
                title={errorMessage}
            />
        </>
    );
};

export default AdminConfigPage;